import { render, staticRenderFns } from "./ServiceItemEditor.vue?vue&type=template&id=2471153c&"
import script from "./ServiceItemEditor.vue?vue&type=script&lang=js&"
export * from "./ServiceItemEditor.vue?vue&type=script&lang=js&"
import style0 from "./ServiceItemEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VIcon,VSelect,VSwitch,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2471153c')) {
      api.createRecord('2471153c', component.options)
    } else {
      api.reload('2471153c', component.options)
    }
    module.hot.accept("./ServiceItemEditor.vue?vue&type=template&id=2471153c&", function () {
      api.rerender('2471153c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/agreements/schema/ServiceItemEditor.vue"
export default component.exports